import { METHOD, webRequest } from '../../client/HttpClient';
import { API } from '../../client/RouteConstants';
import { buildURL, logAPIErrorToNewrelic } from '../utils';
import { ACTION, Analytics } from '../../analytics/analytics';
import { APIResult } from '../APIResult';
import {
    trackEvent as AdobetrackEvent,
    RemoveFromWishlist as AdobeRemoveFromWishlist,
} from '@JohnLewisPartnership/jl-analytics-event-stream';

export const deleteWishListSku = async (skuId: string, mode?: string): Promise<APIResult<WishListItem[]>> => {
    const url = buildURL(`${API.WISH_LISTS}/items/${skuId}?productMode=true&includesImages=true`);

    const request: RequestInit = {
        method: METHOD.DELETE,
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
    };

    const res = await webRequest(url, request);

    const result = new APIResult<WishListItem[]>();
    if (!res) {
        logAPIErrorToNewrelic(`deleteWishListSku`, `No response`, {
            skuId,
            ...request,
            url: url,
            response: res,
        });
        return result;
    }

    if (res.status === 401) {
        result.showError = false;
    }

    if (res.ok) {
        if (mode === 'icon-placeholder') {
            Analytics.dispatchAdobeAnalytics(ACTION.REMOVE_FROM_WISH_LIST_PLP);
        } else {
            Analytics.dispatchAdobeAnalytics(ACTION.REMOVE_FROM_WISH_LIST);
        }
        // new analytic event
        AdobetrackEvent(AdobeRemoveFromWishlist, {
            triggeringImplementationId: 'add-to-wishlist-component',
            originatingImplementationId: 'add-to-wishlist-component',
            type: mode === 'icon-placeholder' ? 'plp' : 'pdp',
            page: {
                name: window.jlData?.page?.pageInfo?.pageName,
                type: window.jlData?.page?.pageInfo?.pageType,
            },
            basket: {
                products: [],
                subTotal: 0,
                productCount: 0,
                quantity: 0,
            },
        });
        const customEvent = new CustomEvent('ADD_TO_WISHLIST_ESI:REMOVE_SUCCESS', {
            detail: {
                code: 'wishlist remove success',
            },
        });
        window.dispatchEvent(customEvent);
        result.data = ((await res.json()) as WishlistResponse).wishLists;
        result.success = true;
    } else {
        logAPIErrorToNewrelic(`deleteWishListSku`, `Not Ok response`, {
            skuId,
            request: request,
            reqUrl: url,
            ...res,
        });
    }

    return result;
};
